import type { EventCategoryDto } from '@upme/contracts';
import { Badge } from '@upme/ui/components/badge';
import { useMemo } from 'react';

interface Props {
  categories: ReadonlyArray<EventCategoryDto>;
  value: string[];
  onChange: (next: string[]) => void;
}

export function CategoryMultiSelect({ categories, value, onChange }: Props) {
  const selected = useMemo(() => new Set(value), [value]);

  const toggle = (id: string) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else if (next.size < 6) next.add(id);
    onChange(Array.from(next));
  };

  const activeCategories = categories.filter((c) => c.isActive || selected.has(c.id));

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {activeCategories.map((c) => {
          const on = selected.has(c.id);
          return (
            <button
              type="button"
              key={c.id}
              onClick={() => toggle(c.id)}
              className="cursor-pointer outline-hidden focus-visible:ring-2 focus-visible:ring-ring rounded-md"
            >
              <Badge variant={on ? 'default' : 'outline'}>
                {c.icon ? `${c.icon} ` : ''}
                {c.name}
              </Badge>
            </button>
          );
        })}
      </div>
      <p className="text-xs text-muted-foreground">Выбрано {selected.size}/6 (минимум 1)</p>
    </div>
  );
}
